import { VideoFormValues } from "../components";
import { ContentVideoListItem } from "../content.types";

export const getInitialVideoFormValues = (
  editableVideo: ContentVideoListItem | null
): VideoFormValues => ({
  id: editableVideo?.id,
  title: editableVideo?.title ?? "",
  description: editableVideo?.description ?? "",
  targetResellerLevel: editableVideo?.targetResellerLevel ?? null,
  isOrderTutorial: editableVideo?.isOrderTutorial ?? false,
  isWebviewTutorial: editableVideo?.isWebviewTutorial ?? false,
  video: editableVideo?.video ?? null,
  thumbnail: editableVideo?.thumbnail ?? null
});
